import { Registry } from '@react-registry'

export const withInlineReference = editor => {
    const { isInline, isVoid } = editor;

    editor.isVoid = element => {
        let isNotRef = element.type !== 'reference';

        if (isNotRef) return isVoid(element);

        const displayType = element?.attrs?.['display-type'];
        const allowVoid = ['inline', 'block', 'display', 'download'];
        return allowVoid.includes(displayType);
    }

    editor.isInline = (element) => {
        let isNotRef = element.type !== 'reference';

        if (isNotRef) return isInline(element);

        const displayType = element?.attrs?.['display-type'];
        const inlineElement = ['display', 'download'];
        const isElementInline = (element?.attrs?.inline && inlineElement.includes(displayType)) || false
        const allowInline = ['inline', 'link'];
        return allowInline.includes(displayType) || isElementInline;
    }

    return editor;
}

Registry.register(withInlineReference, {
    id: 'withReference',
    registry: 'v2.plugin'
})